import React from 'react'
import Routes from './pages/Routes'
import { ThemeProvider } from 'styled-components'
import { defaultTheme } from './styled-theme'
import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import { SavingContextProvider } from './hooks/useSaving'
import { AccountContextProvider } from './hooks/useAccount'
import ErrorBoundary from './res/ErrorBoundary'
import { ModalDialogProvider } from './hooks/useModalDialog'
import WebApiErrorHandler from './res/WebApiErrorHandler'
import { BrowserRouter as Router } from 'react-router-dom'
import ScrollToTop from './core/ScrollToTop'
import BrowserSizeError from './components/core/BrowserSizeError'
import GA from './GA'


// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
const stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY)

function App() {
    return (
        <Elements stripe={stripePromise}>
            <ErrorBoundary>
                <ThemeProvider theme={defaultTheme}>
                    <SavingContextProvider>
                        <Router>
                            <GA />
                            <ScrollToTop />
                            <AccountContextProvider>
                                <ModalDialogProvider>
                                    <WebApiErrorHandler>
                                        <Routes />
                                    </WebApiErrorHandler>
                                </ModalDialogProvider>
                            </AccountContextProvider>
                            <BrowserSizeError />
                        </Router>
                    </SavingContextProvider>
                </ThemeProvider>
            </ErrorBoundary>
        </Elements>
    )
}

export default App
